export default __webpack_public_path__ + "static/media/mainLogos.657fc35a.png";